export default {"src":"/_next/static/media/map.3607e130.svg","height":927,"width":981,"blurWidth":0,"blurHeight":0};